export const PROFILE_EMAIL_ADDRESSES_ERROR = 'PROFILE_EMAIL_ADDRESSES_ERROR';
export const PROFILE_EMAIL_ADDRESSES_LOADING = 'PROFILE_EMAIL_ADDRESSES_LOADING';
export const PROFILE_EMAIL_ADDRESSES_SUCCESS = 'PROFILE_EMAIL_ADDRESSES_SUCCESS';